var _excluded = ["options", "children", "value", "style", "className", "undefinedText", "onChange"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Space, Tag } from 'antd';
import React from 'react';
var DropdownTag = function DropdownTag(props) {
  var options = props.options,
    children = props.children,
    value = props.value,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className,
    _props$undefinedText = props.undefinedText,
    undefinedText = _props$undefinedText === void 0 ? "Undefined" : _props$undefinedText,
    onChange = props.onChange,
    rest = _objectWithoutProperties(props, _excluded);
  var items = options.filter(function (o) {
    return o.value !== value;
  }).map(function (option) {
    return {
      key: option.value,
      label: option.label
    };
  });
  var selectedOption = value ? options.find(function (o) {
    return o.value === value;
  }) : null;
  var onSelect = function onSelect(_ref) {
    var key = _ref.key;
    return onChange(key);
  };
  return /*#__PURE__*/React.createElement(Dropdown, {
    menu: {
      items: items,
      onClick: onSelect
    }
  }, /*#__PURE__*/React.createElement(Tag, _extends({
    className: className,
    style: style
  }, rest), /*#__PURE__*/React.createElement(Space, null, children || (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) || undefinedText, /*#__PURE__*/React.createElement(DownOutlined, null))));
};
export default DropdownTag;